import { render, staticRenderFns } from "./publication.vue?vue&type=template&id=42bdb7d6&scoped=true"
import script from "./publication.vue?vue&type=script&lang=js"
export * from "./publication.vue?vue&type=script&lang=js"
import style0 from "./publication.vue?vue&type=style&index=0&id=42bdb7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bdb7d6",
  null
  
)

export default component.exports